import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { CopyTextDirective } from '@app/shared/directives/copy-text.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-request-waiting-for-payment-info',
    imports: [
        CommonModule,
        TranslateModule,
        CopyTextDirective
    ],
    templateUrl: './request-waiting-for-payment-info.component.html',
    styleUrls: ['./request-waiting-for-payment-info.component.scss']
})
export class RequestWaitingForPaymentInfoComponent implements OnInit {

  @Input() trackingNumber: string;
  constructor(
    ) { }

  ngOnInit() {
  }

}
